const AboutSection = ({ children, style }) => {
    return (
        <div className="about-section__13654" style={style}>
            {children}
        </div>
    )
}

export default AboutSection;